import styled, { css } from "styled-components";

export const WrapStyle = styled.div<{ vertical?: boolean }>`
  display: flex;
  align-items: center;
  gap: 2rem;

  ${({ vertical }) =>
    vertical &&
    css`
      flex-direction: column;
      align-items: stretch;
      gap: 1.6rem;
    `};

  ${({ theme }) => theme.media.small} {
    flex-direction: column;
    align-items: unset;
    gap: 0.6rem;
  }
`;

export const FieldLabel = styled.div`
  width: 19.7rem;
  flex-shrink: 0;
  ${({ theme }) => theme.typography.body1.regular}

  ${({ theme }) => theme.media.small} {
    width: 100%;
  }
`;

export const FieldBody = styled.div`
  max-width: 70.9rem; // WORK 문서 toast-ui 에디터 너비 버그로 인해 추가
  flex: 1;

  & > * {
    width: 100%;
  }

  ${({ theme }) => theme.media.small} {
    width: 100%;
  }
`;
